/**
 * Binary <-> base64, working the same way in the browser and in node.
 *
 * `btoa`/`atob` are standard globals in both, but they only speak "binary
 * string", and feeding a 20 kB replay through `String.fromCharCode(...bytes)`
 * blows the argument stack. Hence the chunking.
 */

const CHUNK = 0x8000;

export function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}

export function base64ToBytes(text: string): Uint8Array {
  const binary = atob(text);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}
